import React from 'react'
import './footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>© 2025 Edusity. All rights reserved.</p>
            <ul>
                <li><a href='https://www.google.com/' target="_blank">Terms of Services</a></li>
                <li><a href='https://www.google.com/' target="_blank">Privacy Policy</a></li>
            </ul>
        </div>
    )
}

export default Footer
